<script lang="ts">
	import { Input, InputGroup } from "sveltestrap";
	export let value = "";
	export let type = "text";
	export let placeholder = "";
	export let name = "";
	export let field = {};
	export let props = {};
	export let required = false;
	export let keypress = undefined;
	export let error = false;
	export let errorText = "";
	export let onInput = undefined;
	export let disabled = false;
	export let id = "";
	export let min = undefined;
	export let step = undefined;
	export let search = false;
	export let postfix = "";
	export let onChange = undefined;
	export let classes = "";
	export let maxlength = 1000;
</script>

<div>
	<InputGroup>
		<Input
			bind:value
			{type}
			{id}
			{placeholder}
			{name}
			{...field}
			{...props}
			class={`form-control getgo input ${error ? "danger" : ""} ${
				search ? "search-icon" : ""
			} ` + classes}
			{required}
			on:keypress={keypress}
			on:input={onInput}
			{disabled}
			{min}
			{step}
			{maxlength}
			on:change={onChange}
		/>
		{#if postfix && !error}
			<span class="postfix">{postfix}</span>
		{/if}
	</InputGroup>
	{#if error}
		<small class="error-text">{errorText}</small>
	{/if}
</div>

<style>
	.postfix {
		position: absolute;
		right: 10px;
		top: 50%;
		transform: translateY(-50%);
		color: var(--on-surface-variant);
	}
	:global(
			[type="number"]::-webkit-inner-spin-button,
			input[type="number"]::-webkit-outer-spin-button
		) {
		-webkit-appearance: none;
		margin: 0;
	}

	:global(input[type="number"]) {
		-moz-appearance: textfield;
	}

	:global(input:disabled) {
		color: rgba(0, 0, 0, 0.6);
	}
</style>
